module.exports = "/static/assets/0e370ab3cadb27d9b1271cb732ec5fc5.png";